import { Box } from '@mui/material';

import { WorklistTable } from '~/scenes/PeopleModule/components/Tabs/CollaborationTab/WorklistTable';

export const CollaborationTab = () => {
  return (
    <Box>
      <WorklistTable />
    </Box>
  );
};
